'use client'

import React from 'react'
import classNames from 'classnames'
import {
  getTwoLetterISOLanguageName,
  constants,
  Language,
  getCultureCode,
  UserSettings,
} from '@dustin-web/microsite-config'
import { useSiteContext, useUserSettings } from '@dustin-web/microsite-components/src/hooks'
import Cookies from 'universal-cookie'
import { useCookieState } from '@dustin-web/microsite-components/src/hooks/use-cookie-state'

const cookies = new Cookies()
const ONE_YEAR = 365 * 24 * 60 * 60

const SiteLangSwitcher = () => {
  const { availableLanguages } = useSiteContext()
  const { selectedContactId, showPricesInclVat, language, personalizationConsent } =
    useUserSettings()
  const cookieState = useCookieState()

  const setLanguage = (language: Language) => {
    const isPunchout = !!cookieState.cookies.punchOutTicket

    if (isPunchout) {
      cookies.set(constants.cookies.userSettings.language, getCultureCode(language), {
        maxAge: ONE_YEAR,
        path: '/',
        sameSite: 'none' as 'none' | 'lax',
        secure: true,
      })
    } else {
      cookies.set(constants.cookies.userSettings.language, getCultureCode(language), {
        maxAge: ONE_YEAR,
        path: '/',
      })
    }

    const userParams: UserSettings = {
      language,
      selectedContactId,
      showPricesInclVat,
      personalizationConsent,
    }

    cookies.set(constants.cookies.userParams, userParams, {
      maxAge: ONE_YEAR,
      path: '/',
    })

    window.location.reload()
  }

  return (
    <ul className="c-header__site-lang-switcher ul-stripped u-fs-14">
      <li className="c-pipe-separator">
        {availableLanguages.map((lang, i) => {
          const twoLetterISOLanguageName = getTwoLetterISOLanguageName(lang)

          return (
            <button
              key={i}
              data-ga-title={`lang-switcher-${twoLetterISOLanguageName}`}
              className={classNames('c-header__site-lang-switcher-link u-mb-0 button-stripped', {
                'c-header__site-lang-switcher-link--active': language === lang,
              })}
              onClick={() => setLanguage(lang)}>
              {twoLetterISOLanguageName.toUpperCase()}
            </button>
          )
        })}
      </li>
    </ul>
  )
}

export default SiteLangSwitcher
